import React from 'react';
import { SmartphoneIcon, SparklesIcon, ShoppingBagIcon } from 'lucide-react';
export function PatientExperience() {
  return <section className="py-20 bg-white" data-id="element-88">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-90">
          <div data-id="element-91">
            <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-92">
              A Delightful Experience for Patients
            </h2>
            <p className="text-xl text-gray-600 mb-8" data-id="element-93">
              Lola makes therapeutic diet shopping as easy as ordering from
              their favorite grocery store—because it is.
            </p>

            <div className="space-y-6" data-id="element-94">
              <div className="flex gap-4" data-id="element-95">
                <div className="flex-shrink-0 w-12 h-12 bg-green-100 text-green-600 rounded-xl flex items-center justify-center" data-id="element-96">
                  <SparklesIcon className="w-6 h-6" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-99">
                    Smart Recommendations
                  </h3>
                  <p className="text-gray-600" data-id="element-100">
                    Lola's AI guides patients to diet-compliant choices from
                    their local store's inventory
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-101">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-100 text-orange-600 rounded-xl flex items-center justify-center" data-id="element-102">
                  <ShoppingBagIcon className="w-6 h-6" data-id="element-103" />
                </div>
                <div data-id="element-104">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-105">
                    Instacart Integration
                  </h3>
                  <p className="text-gray-600" data-id="element-106">
                    Shop from familiar local stores with same-day delivery
                    through Instacart
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-107">
                <div className="flex-shrink-0 w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center" data-id="element-108">
                  <SmartphoneIcon className="w-6 h-6" data-id="element-109" />
                </div>
                <div data-id="element-110">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-111">
                    Simple "Buy Now"
                  </h3>
                  <p className="text-gray-600" data-id="element-112">
                    No complex meal planning—just tap to add approved items to
                    cart
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-113">
            <div className="bg-gradient-to-br from-green-400 to-emerald-500 rounded-3xl p-8 shadow-2xl" data-id="element-114">
              <div className="bg-white rounded-2xl p-6 shadow-xl" data-id="element-115">
                <div className="flex items-center gap-3 mb-6" data-id="element-116">
                  <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center" data-id="element-117">
                    <ShoppingBagIcon className="w-6 h-6 text-white" data-id="element-118" />
                  </div>
                  <div data-id="element-119">
                    <div className="font-bold text-gray-900" data-id="element-120">
                      Your Diet Plan
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-121">
                      Low Sodium • Heart Healthy
                    </div>
                  </div>
                </div>

                <div className="space-y-3 mb-6" data-id="element-122">
                  <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4" data-id="element-123">
                    <div className="flex items-center justify-between mb-2" data-id="element-124">
                      <span className="font-semibold text-gray-900" data-id="element-125">
                        Fresh Spinach
                      </span>
                      <span className="text-green-600 font-bold" data-id="element-126">
                        ✓ Perfect
                      </span>
                    </div>
                    <div className="text-sm text-gray-600" data-id="element-127">
                      Low sodium, high in nutrients
                    </div>
                  </div>

                  <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4" data-id="element-128">
                    <div className="flex items-center justify-between mb-2" data-id="element-129">
                      <span className="font-semibold text-gray-900" data-id="element-130">
                        Wild Salmon
                      </span>
                      <span className="text-green-600 font-bold" data-id="element-131">✓ Great</span>
                    </div>
                    <div className="text-sm text-gray-600" data-id="element-132">
                      Omega-3 rich, heart healthy
                    </div>
                  </div>

                  <div className="bg-orange-50 border-2 border-orange-200 rounded-xl p-4" data-id="element-133">
                    <div className="flex items-center justify-between mb-2" data-id="element-134">
                      <span className="font-semibold text-gray-900" data-id="element-135">
                        Canned Soup
                      </span>
                      <span className="text-orange-600 font-bold" data-id="element-136">
                        ⚠ High Sodium
                      </span>
                    </div>
                    <div className="text-sm text-gray-600" data-id="element-137">
                      Try low-sodium version instead
                    </div>
                  </div>
                </div>

                <button className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all" data-id="element-138">
                  Add to Cart
                </button>
              </div>
            </div>

            <div className="absolute -top-6 -right-6 w-24 h-24 bg-orange-400 rounded-full opacity-20 blur-2xl" data-id="element-139"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-green-400 rounded-full opacity-20 blur-2xl" data-id="element-140"></div>
          </div>
        </div>
      </div>
    </section>;
}